// API constants
export const SEARCH_API_PAGE_SIZE = 24;
export const BROWSE_API_PAGE_SIZE = 24;
export const BROWSE_API_FACETS_STALE_TIME = 1000 * 60 * 60 * 24; // 24 hours
export const BROWSE_API_RESULTS_STALE_TIME = 1000 * 60 * 60 * 24; // 24 hours
export const LEAN_FACET_QUERY_RESULTS_PER_PAGE = 1;
export const LEAN_FACET_STALE_TIME = BROWSE_API_RESULTS_STALE_TIME; // match product grid — same underlying data
export const FED_GRAPH_PRICING_STALE_TIME = 1000 * 60 * 5; // 5 minutes
export const FED_GRAPH_RELATED_PRODUCTS_STALE_TIME = 1000 * 60 * 5; // 5 minutes

// LHN (Left Hand Nav) constants
export const LHN_WIDTH = 0;
export const GAP_BETWEEN_LHN_AND_VIRTUAL_SCROLL = 0;
export const LHN_WIDTH_WITH_PADDING =
  LHN_WIDTH + GAP_BETWEEN_LHN_AND_VIRTUAL_SCROLL;

// Grid Layout constants
export const OUTER_GRID_PADDING_MOBILE = 0;
export const OUTER_GRID_PADDING_DESKTOP = 0;
export const GAP_BETWEEN_GRID_COLUMNS_MOBILE = 2;
export const GAP_BETWEEN_GRID_COLUMNS_DESKTOP = 4;
export const GAP_BETWEEN_GRID_ROWS_MOBILE = 2;
export const GAP_BETWEEN_GRID_ROWS_DESKTOP = 4;
export const MAX_GRID_WIDTH = Infinity;

// Grid Card constants
const RESERVED_GRID_SWATCHES_HEIGHT = 32 + 2 * 8; // swatches + vertical padding
const RESERVED_PRODUCT_INFO_HEIGHT = 110; // max product card name, promo, price, marketing callout
const RESERVED_BUFFER_HEIGHT = 18; // 1 row of buffer space for text overflow on resize
export const RESERVED_SPACE_FOR_CARD_INFO =
  RESERVED_GRID_SWATCHES_HEIGHT +
  RESERVED_PRODUCT_INFO_HEIGHT +
  RESERVED_BUFFER_HEIGHT;
export const ADDITIONAL_SPACE_FOR_CARD_INFO_SAVAGE_MOBILE = 30;
export const RESERVED_SPACE_FOR_CARD_INFO_SAVAGE_MOBILE =
  RESERVED_SPACE_FOR_CARD_INFO + ADDITIONAL_SPACE_FOR_CARD_INFO_SAVAGE_MOBILE;
export const MAX_CARD_WIDTH = 577; // Largest intrinsic card dimensions is 577x888
export const GRID_CARD_TYPES = {
  PRODUCT: 'product',
  ASSET: 'asset',
};
export const DEFAULT_VIDEO_ASPECT_RATIO = 1.4; // refer to productGrid.js for more details
export const VIDEO_AUTOPLAY_THRESHOLD = 0.3; // IntersectionObserver threshold for auto-playing videos

// Virtual Scroll constants
export const RESIZE_THROTTLE = 0; // increase this if we see performance issues, keep close to 0 for smoothness
export const VIRTUAL_SCROLL_OVERSCAN = 3; // number of virtual rows to render above and below the viewport. Kept low to limit the maximum number of concurrently mounted Vimeo iframes / decoded images, which dominate memory on mobile.
export const VIRTUAL_SCROLL_GRID_ID = 'virtual-scroll-grid'; // anchor for scrolling to the top of the grid after a filter or sort option is applied
export const VIRTUAL_SCROLL_GRID_SCROLL_OFFSET = -175; // offset to show the grid header after scrolling to the top of the grid
export const VIRTUAL_SCROLL_GRID_SCROLL_DELAY = 100; // delay to allow for any layout changes before scrolling

// Filter constants
export const CUSTOM_BRA_BAND_FILTER = {
  displayName: 'Band Size',
  name: 'size_band',
};
export const CUSTOM_BRA_CUP_FILTER = {
  displayName: 'Cup Size',
  name: 'size_cup',
};
export const CUSTOM_COLOR_FILTER = {
  displayName: 'Custom Color',
  name: 'custom_color',
};
export const LAYOUT_TYPE = {
  FILTER_PANEL: 'FILTER_PANEL',
  QUICK_FILTER: 'QUICK_FILTER',
};

// Skeleton Loader constants
export const NUM_SKELETON_CATEGORY_TABS = 7;

// Discovery Guide constants
export const DISCOVERY_GUIDE_MIN_THUMB_WIDTH_PERCENT = 20;
export const DISCOVERY_GUIDE_SCROLL_STEP_RATIO = 0.9;

// Selected Filters Panel constants
export const SELECTED_FILTERS_EXPAND_DURATION_MS = 300;
export const SELECTED_FILTERS_EXPAND_EASING = 'cubic-bezier(0.32, 0, 0.14, 1)';
export const SELECTED_FILTERS_COLLAPSE_DURATION_MS = 220;
export const SELECTED_FILTERS_COLLAPSE_EASING = 'cubic-bezier(0, 0, 0.2, 1)';
export const SELECTED_FILTERS_CHIP_ENTER_DURATION_MS = 200;
export const SELECTED_FILTERS_CHIP_ENTER_STAGGER_MS = 14;
export const SELECTED_FILTERS_CHIP_ENTER_DELAY_MS = 70;
export const SELECTED_FILTERS_CHIP_ENTER_EASING =
  'cubic-bezier(0.22, 1, 0.36, 1)';
export const SELECTED_FILTERS_CHIP_EXIT_DURATION_MS = 110;
export const SELECTED_FILTERS_CHIP_Y_OFFSET_PX = 4;
export const SELECTED_FILTERS_BUTTON_FADE_OUT_MS = 70;
export const SELECTED_FILTERS_COMPACT_BUTTON_FADE_IN_MS = 100;
